module.exports = __webpack_public_path__ + "img/contact_banner.c94d3e2a.png";